import React, {Component} from 'react';
import classNames from 'classnames';
import {FormButton} from '@social-native/snclient-ui';
import '@social-native/snclient-ui/dist/style.css';

export default class PostGridOptions extends Component {
    displayDates() {
        const {fullStartDate, fullEndDate} = this.props;

        if (fullStartDate && !fullEndDate) {
            return <h4>{fullStartDate}</h4>;
        }

        if (fullStartDate && fullEndDate) {
            return (
                <h4>
                    {fullStartDate} - {fullEndDate}
                </h4>
            );
        }
    }

    render() {
        const {expanded} = this.props;

        const dates = this.displayDates();

        const advancedOptionsClasses = classNames('advanced-options', {
            'advanced-options-expanded': expanded
        });
        const chevronClasses = classNames('fa', expanded ? 'fa-caret-down' : 'fa-caret-up');

        return (
            <div className={advancedOptionsClasses}>
                <FormButton 
                    icon={chevronClasses}
                    color="gray" 
                    alt
                    onClick={this.props.handleAdvancedOptionsClick}
                    role="button"
                >
                    Advanced Options
                </FormButton>
        
                {dates && (<div className="campaign-date">{dates}</div>)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_options.js